import { Link } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import "../asset/css/back.css";
import tvImage from "../asset/images/Button_GoToMainPlayer2.png";
import main_logo from "../asset/images/LoginLogo.png";
import user_logo from "../asset/icons/user.png";
import menu from "../asset/icons/menu.png";
import { NavLink } from "react-router-dom";


function Back() {
  const userDetails = sessionStorage.getItem("userDetails");
    const [isOpen, setIsOpen] = useState(false);
    const [isHumbergerOpen, setIsHumbergerOpen] = useState(false);
	const dropdownRef = useRef(null);
	const dropdownRefHumberger = useRef(null);
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

      const location = useLocation();
      const params = new URLSearchParams(location.search);
      const embededValue = params.get('embeded');

	const toggleHumbergerDropdown = () => {
      setIsHumbergerOpen(!isHumbergerOpen);
    };

	const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }

	  if (dropdownRefHumberger.current && !dropdownRefHumberger.current.contains(event.target)) {
        setIsHumbergerOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
		const handleOrientationChange = (e) => {
		const userAgent = navigator.userAgent.toLowerCase();
		const userAgentCheck = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
		const screenWidthCheck = window.innerWidth < 1024;
		if (userAgentCheck || screenWidthCheck) {
			if (e.matches) {
				document.body.classList.add('portrait');
				document.body.classList.remove('landscape');
			} else {
				document.body.classList.remove('portrait');
				document.body.classList.add('landscape');
			}
		}
	};

  	// useEffect(() => {

    // const headerElement = document.querySelector('.header.header');

    // // Check if the element exists to avoid errors
    // if (headerElement && embededValue !== null) {
    //   // Add the 'd-none' class to hide the element
    //   headerElement.classList.add('d-none');
    // }

		// const mediaQuery = window.matchMedia("(orientation: portrait)");
		// handleOrientationChange(mediaQuery);
		// mediaQuery.addEventListener('change', handleOrientationChange);

		// // Cleanup event listener on component unmount
		// return () => {
		// mediaQuery.removeEventListener('change', handleOrientationChange);
		// };
  	// }, []);
    useEffect(() => {

      const headerElement = document.querySelector('.header.header');
    
      // Check if the element exists to avoid errors
      if (headerElement && embededValue !== null) {
        // Add the 'd-none' class to hide the element
        headerElement.classList.add('d-none');
      }
    
      const mediaQuery = window.matchMedia("(orientation: portrait)");
      handleOrientationChange(mediaQuery);
    
      // Compatibility for both modern and older browsers
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handleOrientationChange);
      } else {
        mediaQuery.addListener(handleOrientationChange);
      }
    
      // Cleanup event listener on component unmount
      return () => {
        if (mediaQuery.removeEventListener) {
          mediaQuery.removeEventListener('change', handleOrientationChange);
        } else {
          mediaQuery.removeListener(handleOrientationChange);
        }
      };
    
    }, []);

    

  return (
    <>
      <header className="header" style={{padding:"0 24px"}}>
        {/* <div className="tv-logo"></div> */}
        <div className="main-logo justify-content-start m-0">
          <NavLink to="home-player" className="img_link">
            <img src={main_logo} alt="logo" className="mx-0" />
          </NavLink>
        </div>
        <div className="user-menu-logo w-100">
          {/* <NavLink to="make" className="img_link me-2">
             <img
              src={menu}
              alt="menu_logo"
              className=""
              style={{ width: "30px" }}
              data-bs-toggle="dropdown"
            />
          </NavLink> */}

		  <Link
            className="img_link me-2"
            style={{ position: "relative" }}
			ref={dropdownRefHumberger}
          >

            <img
              src={menu}
              alt="menu"
              className="userMenuLogo dropdown-toggle"
              style={{ width: "30px", cursor: "pointer" }}
              onClick={toggleHumbergerDropdown}
            />
			{isHumbergerOpen && (
            <ul className="CustomDropdown rounded overflow-hidden">
                <li style={{ cursor: 'pointer' }} onClick={toggleHumbergerDropdown}>
					<NavLink to="/make">
						<i className='bx bx-log-in-circle'></i>
						<span>Make Playlist</span>
					</NavLink>
                </li>
           
		   
                <li style={{ cursor: 'pointer' }} onClick={toggleHumbergerDropdown}>
					 <NavLink to="https://tvadi.com/market">
					 	<i className='bx bx-log-in-circle'></i>
						<span>Marketplace</span>
              		</NavLink>
                </li>
            </ul>
			)}
          </Link>

          <Link
            className="img_link me-2"
            style={{ position: "relative" }}
			ref={dropdownRef}
          >

            <img
              src={user_logo}
              alt="menu_logo"
              className="userMenuLogo dropdown-toggle"
              style={{ width: "30px", cursor: "pointer" }}
              onClick={toggleDropdown}
            />
			{isOpen && (
            <ul className="CustomDropdown rounded overflow-hidden">
                <li style={{ cursor: 'pointer' }} onClick={toggleDropdown}>
					<NavLink to="/">
						<i className='bx bx-log-in-circle'></i>
						<span>Home</span>
					</NavLink>
                </li>
           
		   
                {/* <li style={{ cursor: 'pointer' }} onClick={toggleDropdown}>
					 <NavLink to="/playlist">
					 	<i className='bx bx-log-in-circle'></i>
						<span>My Playlist</span>
              		</NavLink>
                </li> */}

             
                {/* <li style={{ cursor: 'pointer' }} onClick={toggleDropdown}>
					 <NavLink to="/make">
						<i className='bx bx-log-in-circle'></i>
						<span>Make</span>
					 </NavLink>
                </li> */}
              {userDetails == null ?
                (<>
                    <li style={{ cursor: 'pointer' }} onClick={toggleDropdown}>
                  		<NavLink to="/login">
							<i className='bx bx-log-in-circle'></i>
							<span>Login</span>
                  		</NavLink>
                    </li>
                    <li style={{ cursor: 'pointer' }} onClick={toggleDropdown}>
    	                <NavLink to="/register">
							<i className='bx bx-log-out-circle'></i>
							<span>Create Account</span>
	                    </NavLink>
                    </li>
                </>)
                :
                (<>


                    <li style={{ cursor: 'pointer' }} onClick={toggleDropdown}>
                  		<NavLink to="/profile">
							<i className='bx bx-log-in-circle'></i>
							<span>My Profile</span>
                  		</NavLink>
                    </li>
                    <li style={{ cursor: 'pointer' }} onClick={toggleDropdown}>
                  		<NavLink to="/logout">
							<i className='bx bx-log-out-circle'></i>
							<span>Logout</span>
	                  	</NavLink>
                    </li>
                </>)
              }
            </ul>
			)}
          </Link>

          <NavLink to="home-player" className="img_link">
            <img src={tvImage} alt="tvIcon" className="me-0" />
          </NavLink>
        </div>

      </header>
    </>
  );
}
export default Back;